import { atom, useRecoilState } from "recoil";
import axios from "axios";
import LanguageJSON from "../utils/language.json";
import A from "../utils/url.utils";
import Cookies from "js-cookie";

const languageAtom = atom({
  key: "languageAtom",
  // default: null,
  default: LanguageJSON,
});

export default function useLanguage() {
  const [language, setLanguage] = useRecoilState(languageAtom);

  const fetchLanguage = async (clientId, lang) => {
    try {
      const { data } = await axios.post(A.HOST + A.ADMIN_LANGUAGE_KEYS, { clientId: clientId || Cookies.get("clientId"), languageCode: lang });
      if (data.languageKeys) setLanguage(data.languageKeys);
      return data.languageKeys || language;
    } catch (err) {}
  };

  return { language, setLanguage, fetchLanguage };
}
